import React, { createContext, useContext, useEffect, useState } from "react";
import { database } from "../config/config";
import { get, ref } from "firebase/database";
import { GetUserList } from "../pages/admin/userList";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchAllCompanyList } from "../apis/company/companyList";
import { setLoaderCallbacks, clearPageCache } from "../services/apiService";

const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);
const ContextProvider = ({ children }) => {
  const [openReport, setOpenReport] = useState(false);
  const [openInVoicing, setOpenInVoicing] = useState(false);
  const [openscheduleGuardManagement, setOpenscheduleGuardManagement] =
    useState(false);

  const [showSideNav, setShowSideNav] = useState(true);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [isAuthPage, setIsAuthPage] = useState(false);

  const [isVisibleReport, setIsVisibleReport] = useState(false);
  const [isVisibleSchedule, setIsVisibleSchedule] = useState(false);
  const [isVisibleInvoicing, setVisibleInvoicing] = useState(false);
  const [isUserList, setIsUserList] = useState(false);
  const [OpenUserList, setOpenUserList] = useState(false);
  const [removeNav, setRemoveNav] = useState(false);
  const [ShowPopUp, setShowPopUP] = useState(false);
  const [popUpData, setPopUpData] = useState("");

  const [showSignUp, setShowSignUp] = useState(false); // Tracks whether to show the registration form
  
  // Global loading state
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");

  // Set up API service loader callbacks
  useEffect(() => {
    setLoaderCallbacks({
      showLoader: (text) => {
        setLoadingText(text);
        setIsGlobalLoading(true);
      },
      hideLoader: () => {
        setIsGlobalLoading(false);
        setLoadingText("");
      },
    });
  }, []);

  const HandlePopUpClose = () => {
    setShowPopUP(false);
  };

  const [isChangesInCreateReport, setIsChangesInCreateReport] = useState(false);

  const savedLocalStorage = JSON.parse(localStorage.getItem("maxUser"));
  const savedSessionStorage = JSON.parse(sessionStorage.getItem("maxUser"));
  const User = savedLocalStorage || savedSessionStorage;

  const [UserType, setUserType] = useState(User);
  const [isLoading, setIsLoading] = useState(true);

  // popup
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (User?.role === "admin") {
  //     navigate("/home");
  //   } else {
  //     // alert("");
  //     navigate("/");
  //   }
  // }, []);

  const location = useLocation();
  const isPathNameForPasswordVerification =
    location.pathname.includes("/verifyuser");
  
  // Track if we're on auth pages
  useEffect(() => {
    const authPages = ['/', '/login', '/register', '/resetpassword', '/role'];
    const isOnAuthPage = authPages.includes(location.pathname) || 
                        location.pathname.includes('/verifyuser');
    setIsAuthPage(isOnAuthPage);
  }, [location.pathname]);

  // Handle responsive breakpoint detection
  useEffect(() => {
    const checkScreenSize = () => {
      const isMobile = window.innerWidth < 640; // sm breakpoint is 640px
      setIsMobileScreen(isMobile);
    };

    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (User?.role === "admin" && !isPathNameForPasswordVerification) {
      console.log("UserUser123", User);
      // Keep side nav open on md+ screens, only collapse on mobile (sm)
      setShowSideNav(!isMobileScreen);
    } else {
      console.log("UserUser123 no");
      setShowSideNav(false);
    }
  }, [isMobileScreen]);

  const [userCounts, setUserCounts] = useState({
    clientUsers: 0,
    managementUsers: 0,
    securityUsers: 0,
    totalUsers: 0,
    clientList: 0,
  });

  const [clientList, setClientList] = useState([]);
  // useEffect(() => {
  //   // if(user )
  //   GetUserList().then((userList) => {
  //     const clientUsers = userList.filter((user) => user.type === "Client");
  //     const managementUsers = userList.filter(
  //       (user) => user.type === "Management"
  //     );
  //     const securityUsers = userList.filter((user) => user.type === "Security");

  //     setUserCounts((prev) => ({
  //       ...prev,
  //       clientUsers: clientUsers.length,
  //       managementUsers: managementUsers.length,
  //       securityUsers: securityUsers.length,
  //       totalUsers: userList.length,
  //     }));
  //   });

  //   // Fetch client locations
  //   const clientLocationsRef = ref(database, "clientLocations");
  //   get(clientLocationsRef).then((snapshot) => {
  //     if (snapshot.exists()) {
  //       const data = snapshot.val();
  //       const templatesArray = Object.keys(data)
  //         .map((key) => ({
  //           id: key,
  //           ...data[key],
  //         }))
  //         .filter((item) => !item.isDeleted && item.clientName)
  //         .map((value) => ({
  //           ...value,
  //           clientType: "view",
  //           lng: value.lang,
  //         }));
  //       console.log("templatesArray", templatesArray);
  //       setClientList(templatesArray);
  //       setUserCounts((prev) => ({
  //         ...prev,
  //         clientList: templatesArray.length,
  //       }));
  //     }
  //   });
  // }, []);

  const [isAuthUser, setIsAuthUser] = useState(null);

  const { data: companyList } = useQuery({
    queryKey: ["companyList"],
    queryFn: () => fetchAllCompanyList(), // Pass token here
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  return (
    <AppContext.Provider
      value={{
        openReport,
        setOpenReport,
        openscheduleGuardManagement,
        setOpenscheduleGuardManagement,
        showSideNav,
        setShowSideNav,
        isMobileScreen,
        isAuthPage,
        openInVoicing,
        setOpenInVoicing,
        isVisibleReport,
        setIsVisibleReport,
        isVisibleSchedule,
        setIsVisibleSchedule,
        isVisibleInvoicing,
        setVisibleInvoicing,
        isUserList,
        setIsUserList,
        OpenUserList,
        setOpenUserList,
        removeNav,
        setRemoveNav,
        ShowPopUp,
        setShowPopUP,
        popUpData,
        setPopUpData,
        HandlePopUpClose,
        isChangesInCreateReport,
        setIsChangesInCreateReport,
        UserType,
        isLoading,
        setIsLoading,
        userCounts,
        clientList,
        showSignUp,
        setShowSignUp,
        isAuthUser,
        setIsAuthUser,
        companyList,
        isPopupOpen,
        setIsPopupOpen,
        popupMessage,
        setPopupMessage,
        isGlobalLoading,
        setIsGlobalLoading,
        loadingText,
        setLoadingText,
        clearPageCache,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default ContextProvider;
